import { apiAddCustomerApplication } from "Hooks/Api/apiCustomerApplications";
import { observer } from "mobx-react";
import { RouteComponentProps } from "react-router";
import { PageBreadcrumbs } from "Views/Components/Breadcrumbs/PageBreadcrumbs";
import CustomerApplicationFormRenderer from "Views/Components/CustomerApplications/CustomerApplicationFormRenderer";
import AccessIntelSecuredPage from "Views/Components/Security/AccessIntelSecuredPage";
import { TemplateFormProvider } from "Views/Components/TemplateForm/TemplateFormContext";

const Tags = [
	{ label: 'Customer Applications', link: '/approve/customerapplications' },
	{ label: 'New Applicant' },
];

export interface CreateCustomerApplicationPageProps extends RouteComponentProps { }

const CreateCustomerApplicationPage = observer((props: CreateCustomerApplicationPageProps) => {

	return (
		<AccessIntelSecuredPage routeComponentProps={props} product="approve">
			<div className="body-content customer-application-page">
				<div className="invisible-page-wrap">
					<div className="top-container">
						<PageBreadcrumbs tags={Tags} />
					</div>
					<div className="white-box">
						{/* Future: This should be fetched from ApplicationEntity */}
						<TemplateFormProvider initialFormData={{}}>
							<CustomerApplicationFormRenderer onSubmitRequest={apiAddCustomerApplication} />
						</TemplateFormProvider>
					</div>
				</div>
			</div>
		</AccessIntelSecuredPage>
	)
})

export default CreateCustomerApplicationPage;
